import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/luling")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Luling, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Luling & Caldwell County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Luling, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Luling and Caldwell County.",
      keywords: "awnings Luling, awning company Luling, custom awnings Luling, sail shades Luling, patio covers Luling, pergola covers Luling, metal awnings Luling, canvas awnings Luling, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Luling", "Caldwell County"),
  }),
  component: () => <CityHomePage city="Luling" region="Caldwell County" />,
});
